// Intra-day ordering for v2 lines (#1347).
//
// Payday-written lines (lineSubtype TRUE_UP / PAYDAY_FUNDING) carry semantic
// order within their dateStamp: the funding engine computes a true-up from the
// balance inclusive of every line dated on the payday, then writes the payday
// funding on top of the zeroed balance. Chronological rank within one date is
// therefore: user lines, then TRUE_UP, then PAYDAY_FUNDING. lineId cannot be
// the cross-rank tiebreak: deterministic payday ids (pf:/tu:, #1341) do not
// encode write order the way legacy uuidv7 ids happened to.

// budget-date-index does not project lineSubtype, so GSI-fed rows (the budget
// detail list) arrive without it. Deterministic payday ids encode the subtype
// in their prefix by design (#1341), so the prefix is an equivalent source.
// Legacy uuidv7 payday lines have neither and fall back to rank 0, where their
// time-ordered ids already sort them correctly (true-up written before
// funding; catch-up lines written after the day's user lines).
const subtypeOf = (line) => {
  if (line?.lineSubtype) return line.lineSubtype;
  const lineId = line?.lineId;
  if (typeof lineId !== 'string') return undefined;
  if (lineId.startsWith('pf:')) return 'PAYDAY_FUNDING';
  if (lineId.startsWith('tu:')) return 'TRUE_UP';
  if (lineId.startsWith('ru:')) return 'RELEASE_UNSPENT';
  return undefined;
};

// A release (#2103) is the true-up's positive-balance twin: the run writes
// one or the other for a budget on a payday, never both, so they share a rank.
export const paydayLineRank = (line) => {
  const subtype = subtypeOf(line);
  if (subtype === 'PAYDAY_FUNDING') return 2;
  if (subtype === 'TRUE_UP' || subtype === 'RELEASE_UNSPENT') return 1;
  return 0;
};

// Tiebreak for two lines sharing a dateStamp in a newest-first list: the
// chronologically later rank renders first, then lineId keeps same-rank lines
// in a stable order. Running balances derive from display order, so this puts
// the TRUE_UP row at the zeroed balance and PAYDAY_FUNDING at post-funding.
export const compareSameDateDesc = (a, b) => {
  const rankDiff = paydayLineRank(b) - paydayLineRank(a);
  if (rankDiff !== 0) return rankDiff;
  return (b?.lineId || '').localeCompare(a?.lineId || '');
};
